// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3JXa4","field":"styles_field__1Mg5d","fieldCol":"styles_fieldCol__Tx0_b","diffCol":"styles_diffCol__14z45","diff":"styles_diff__2LH3Q"};